import { Modal, Typography } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import useSWR from "swr";
import get from "lodash/get";
import map from "lodash/map";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import intersection from "lodash/intersection";
import upperFirst from "lodash/upperFirst";
import { useState } from "react";
import { useTranslation } from 'next-i18next';

const { Text } = Typography;

const Retails = ({ product, styles }) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);

  const { data: stores, isValidating } = useSWR(
    `/api/pages/product/stores/${get(product, "id")}`,
    (url) => fetch(url).then((r) => r.json()),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    }
  );

  const { data: staticBlocks } = useSWR(
    `/api/lib/v1/blocks`,
    (url) => fetch(url).then((r) => r.json()),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  const notOnStoreMessage = get(
    find(staticBlocks, ["hash", "product_not_on_store"]),
    "content"
  );

  const { store } = product;
  const availableStores = get(product, "store.[0].storeData", []);

  const storesNames = map(stores, "name");
  const availableStoresNames = map(availableStores, "storeName");
  const availableStoresCount = intersection(storesNames, availableStoresNames);

  if (!isValidating && !availableStoresCount.length) {
    return "";
  }

  return (
    <>
      <div className={styles.row}>
        <div className={`${styles.col} ${styles.label}`}>
          {upperFirst(t("product:stores availability"))}:
        </div>
        <div className={`${styles.col} ${styles.value}`}>
          <span className={get(styles, "time-to-arrival")}>
            <u style={{ cursor: "pointer" }}>
              <span onClick={() => setOpenModal(!openModal)}>
                {!isValidating ? (
                  availableStoresCount.length > 0 ? (
                    upperFirst(t('product:on store pieces available', { count: availableStoresCount.length }))
                  ) : notOnStoreMessage ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: notOnStoreMessage }}
                    />
                  ) : (
                    t("product:not available on any store")
                  )
                ) : (
                  <LoadingOutlined />
                )}
              </span>
              <Modal
                title={upperFirst(t("product:stores availability"))}
                visible={openModal}
                footer={false}
                onCancel={() => setOpenModal(false)}
              >
                <div>
                  {map(stores, (item, index) => {
                    return (
                      <div key={`store-${item?.id}-${index}`}>
                        {findIndex(
                          availableStores,
                          (availableStore) =>
                            get(availableStore, "storeName") ==
                            get(item, "name")
                        ) >= 0 ? (
                          <Text type="primary">
                            <b>
                              <CheckOutlined /> {get(item, "name")}
                            </b>
                          </Text>
                        ) : (
                          <Text>
                            <CloseOutlined /> {get(item, "name")}
                          </Text>
                        )}
                      </div>
                    );
                  })}
                </div>
              </Modal>
            </u>
          </span>
        </div>
      </div>
    </>
  );
};

export default Retails;
